import React, { useState, useEffect, useRef } from 'react';
import { ConstructorEventUpdateSQLStatus } from "../../../../Event/event";

const FastMultiplicationGame = () => {
  const [twoDigitNumber, setTwoDigitNumber] = useState(0);
  const [oneDigitNumber, setOneDigitNumber] = useState(0);
  const [step1, setStep1] = useState('');
  const [step2, setStep2] = useState('');
  const [final, setFinal] = useState('');
  const [feedback, setFeedback] = useState('');
  const [correct, setCorrect] = useState(null);
  const containerRef = useRef(null);
  const correctSoundRef = useRef(null);
  const wrongSoundRef = useRef(null);

  useEffect(() => {
    nextQuestion();
  }, []);

  const nextQuestion = () => {
    setTwoDigitNumber(Math.floor(Math.random() * 90) + 10);
    setOneDigitNumber(Math.floor(Math.random() * 8) + 2);
    setStep1('');
    setStep2('');
    setFinal('');
    setFeedback('');
    setCorrect(null);
  };

  const createSparkle = (x, y) => {
    const sparkle = document.createElement('div');
    sparkle.style.position = 'absolute';
    sparkle.style.width = '15px';
    sparkle.style.height = '15px';
    sparkle.style.background = 'radial-gradient(circle, #fbbf24 40%, transparent 60%)';
    sparkle.style.borderRadius = '50%';
    sparkle.style.left = `${x}px`;
    sparkle.style.top = `${y}px`;
    sparkle.style.pointerEvents = 'none';
    sparkle.style.animation = 'sparkleMove 1.2s ease forwards';
    sparkle.style.filter = 'drop-shadow(0 0 4px #fbbf24)';
    sparkle.style.opacity = '0';
    containerRef.current.appendChild(sparkle);
    setTimeout(() => sparkle.remove(), 1200);
  };

  const createMultipleSparkles = () => {
    for (let i = 0; i < 15; i++) {
      const x = Math.random() * containerRef.current.clientWidth * 0.8 + containerRef.current.clientWidth * 0.1;
      const y = Math.random() * containerRef.current.clientHeight * 0.5 + containerRef.current.clientHeight * 0.1;
      setTimeout(() => createSparkle(x, y), i * 80);
    }
  };

  const checkAnswer = () => {
    const tens = Math.floor(twoDigitNumber / 10) * 10;
    const ones = twoDigitNumber % 10;
    const correctStep1 = tens * oneDigitNumber;
    const correctStep2 = ones * oneDigitNumber;
    const correctFinal = correctStep1 + correctStep2;

    if (
      parseInt(step1) === correctStep1 &&
      parseInt(step2) === correctStep2 &&
      parseInt(final) === correctFinal
    ) {
      setFeedback('✅ Correct! Great job!');
      const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
      setCorrect(true);
      correctSoundRef.current.play();
      createMultipleSparkles();
    } else {
      setFeedback(
        `❌ Try again! Hint: Tens × digit = ${correctStep1}, Ones × digit = ${correctStep2}, Sum = ${correctFinal}`
      );
      setCorrect(false);
      wrongSoundRef.current.play();
    }
  };

  return (
    <div
      ref={containerRef}
      style={{
        fontFamily: 'Comic Neue, cursive',
        background: 'linear-gradient(135deg, #fceabb, #f8b500)',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        userSelect: 'none',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <div
        style={{
          background: '#fff',
          padding: '2.5rem 2rem',
          borderRadius: '20px',
          boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
          textAlign: 'center',
          width: '370px'
        }}
      >
        <h2
          style={{
            color: 'rgba(251, 191, 36, 1)',
            fontSize: '22px',
            // marginBottom: '0.8rem',
            textShadow: '2px 2px 4px #b76e03'
          }}
        >
          Fast Two-digit × One-digit
        </h2>

        <p style={{ fontSize: '1.2rem', fontWeight: '600', marginBottom: '1.5rem' }}>
          What is {twoDigitNumber} × {oneDigitNumber}?
        </p>

        {/* Centered Step Layouts */}
        <div style={stepRowStyle}>
          <span style={stepLabel}>Step 1:</span>
          <span style={stepText}>Tens × digit =</span>
          <input
            type="number"
            value={step1}
            onChange={e => setStep1(e.target.value)}
            style={inputStyle}
          />
        </div>

        <div style={stepRowStyle}>
          <span style={stepLabel}>Step 2:</span>
          <span style={stepText}>Ones × digit =</span>
          <input
            type="number"
            value={step2}
            onChange={e => setStep2(e.target.value)}
            style={inputStyle}
          />
        </div>

        <div style={stepRowStyle}>
          <span style={stepLabel}>Step 3:</span>
          <span style={stepText}>Add results =</span>
          <input
            type="number"
            value={final}
            onChange={e => setFinal(e.target.value)}
            style={inputStyle}
          />
        </div>

        <button onClick={checkAnswer} style={buttonStyle}>
          Check
        </button>

        {correct && (
          <button
            onClick={nextQuestion}
            style={{ ...buttonStyle, backgroundColor: '#3b82f6' }}
          >
            Next
          </button>
        )}

        <div
          style={{
            marginTop: '1.3rem',
            fontWeight: '900',
            fontSize: '1.3rem',
            color: correct === true ? '#16a34a' : correct === false ? '#dc2626' : '',
            minHeight: '2rem',
            textShadow:
              correct === true
                ? '0 0 5px #4ade80'
                : correct === false
                ? '0 0 5px #f87171'
                : ''
          }}
        >
          {feedback}
        </div>

        <audio
          ref={correctSoundRef}
          src="https://actions.google.com/sounds/v1/cartoon/clang_and_wobble.ogg"
          preload="auto"
        />
        <audio
          ref={wrongSoundRef}
          src="https://actions.google.com/sounds/v1/cartoon/wood_plank_flicks.ogg"
          preload="auto"
        />
      </div>
    </div>
  );
};

// Centered step rows
const stepRowStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '0.6rem',
  marginBottom: '0.8rem',
  fontSize: '1.1rem',
  fontWeight: 600
};

const stepLabel = {
  color: '#b45309',
  fontWeight: 700
};

const stepText = {
  color: '#4b5563'
};

const inputStyle = {
  padding: '0.6rem',
  width: '80px',
  fontSize: '1.1rem',
  borderRadius: '10px',
  border: '2px solid #fbbf24',
  textAlign: 'center',
  fontWeight: 700
};

const buttonStyle = {
  marginTop: '1.2rem',
  backgroundColor: '#34d399',
  color: 'white',
  border: 'none',
  borderRadius: '15px',
  padding: '0.8rem 2rem',
  fontSize: '1.25rem',
  fontWeight: 700,
  cursor: 'pointer',
  boxShadow: '0 6px #059669'
};

export default FastMultiplicationGame;